import React from "react";
import Datetime from "react-datetime";
import moment from "moment";
import { stringToDate } from "../../util";

import "moment/locale/vi";

function RenderFieldDateTime({
  input,
  startDate,
  maxDate,
  minDate,
  className,
  meta: { touched, error },
}) {
  function validation(currentDate) {
    const validMax =
      !maxDate || (maxDate && currentDate.isBefore(moment(maxDate)));
    const validMin =
      !minDate || (minDate && currentDate.isAfter(moment(minDate)));

    return validMax && validMin;
  }

  return (
    <div
      className={
        "text-left form-control field " + (touched && error ? "error" : "")
      }
    >
      <Datetime
        {...input}
        id={input.name}
        locale="vi"
        timeFormat={false}
        inputProps={{ className: "" }}
        // dateFormat="dd/MM/yyyy"
        onChange={(date) => {
          date && input.onChange(moment(date).format("DD/MM/YYYY"));
        }}
        initialValue={stringToDate(startDate, "dmy")}
        isValidDate={validation}
      />
    </div>
  );
}

export default RenderFieldDateTime;
